export class GroupCriterion {
    id!: string
    groupId!: string
    attributeName!: string
    attributeValue!: string
    attributeValueName!: string
    operator!: string
}
